import React, { useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
import HeadImg from "../../images/bank.svg";
import ListCourses from "../ListCourses/ListCourses";
import Sell from "../../images/sell.png";
import Slider from "../../Components/Swiper/Slider";
import Image1 from "../../images/image1.png";
import Image2 from "../../images/image2.png";
import Image3 from "../../images/image3.png";
import ToLeftImg from "../../images/Arrow 1.svg";
import HeaderImg from '../../images/headerLogo.png'
import CallImg from '../../images/call.svg'
import MessageImg from '../../images/message.svg'
import Placeholder from '../../images/Placeholder.png'
import "./Home.css";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import './CourseSwiper.css';
// import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import uzFlag from '../../images/uzFlag.webp'
import ruFlag from '../../images/ruFlag.png'
import enFlag from '../../images/enFlag.avif'
import Play from '../../images/play.png'
import api from "../../Components/RefreshToken/RefreshToken";
import { API } from "../../constants";
import Teacher from '../../images/teacher.svg'
import Check from '../../images/check.svg'
import Johongir from '../../images/johongir.png'
import Shagzod from '../../images/shagzod.png'
import Marifat from '../../images/marifat.png'
import Login from "../../Components/Login/Login";
import Navbar from "../../Components/Navbar/Navbar";
import { toast } from "react-toastify";

const languages = [
  { code: "uz", flag: uzFlag, name: "uz" },
  { code: "ru", flag: ruFlag, name: "ru" },
  { code: "en", flag: enFlag, name: "en" },
];

const Home = ({ courseId }) => {
  // const [swiperRef, setSwiperRef] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation()
  const [activeNav, setActiveNav] = useState(false);
  const [language, setLanguage] = useState("uz");
  const [open, setOpen] = useState(false);
  const [courses, setCourses] = useState([])
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [user, setUser] = useState(null)
  const slides = [1, 2, 3];

  useEffect(() => {
    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang && languages.find((l) => l.code === storedLang)) {
      setLanguage(storedLang);
      i18n.changeLanguage(storedLang);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      api
        .get(`${API}/profile`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        })
        .then((response) => setUser(response.data))
        .catch((error) => console.error("bu profile err", error));
    }
  }, [isLoginOpen]);

  const handleSelect = (lang) => {
    setLanguage(lang);
    // localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    setOpen(false);
  };
  const currentLang = languages.find((l) => l.code === language);

  const certtificateImages = [
    {
      img: Image1,
      id: 1,
      title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      desc: "International Institute of Finance and Accounting IIFA - a leading provider of professional qualifications in accounting, finance, management lorem",
    },
    {
      img: Image3,
      id: 2,
      title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      desc: "IIFA - draws on an extensive network of professional leaders and experts to provide quality input into the practice of finance, accounting and auditing.",
    },
    {
      img: Image2,
      id: 3,
      title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      desc: "We provide timely, effective and cost-effective training solutions that meet both organizational and individual requirements. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
  ];

  const navItems = [
    { key: "home", label: t("home") },
    { key: "courses", label: t("courses") },
    { key: "partners", label: t("partners") },
    { key: "about", label: t("about") },
  ];


  // const courses = [
  //   {
  //     title: 'International Audit',
  //     price: '100.000 UZS',
  //     details: [
  //       'Manzildan farqlanadi',
  //       'Teaching process: Online',
  //       'Duration: 50 hours',
  //       'Online chat with Teacher',
  //     ],
  //     image: '/images/audit.png',
  //   },
  //   {
  //     title: 'International Audit',
  //     price: '100.000 UZS',
  //     details: [
  //       'Manzildan farqlanadi',
  //       'Teaching process: Online',
  //       'Duration: 50 hours',
  //       'Online chat with Teacher',
  //     ],
  //     image: '/images/audit.png',
  //   },
  //   {
  //     title: 'International Audit',
  //     price: '100.000 UZS',
  //     details: [
  //       'Manzildan farqlanadi',
  //       'Teaching process: Online',
  //       'Duration: 50 hours',
  //       'Online chat with Teacher',
  //     ],
  //     image: '/images/audit.png',
  //   },
  //   {
  //     title: 'International Audit',
  //     price: '100.000 UZS',
  //     details: [
  //       'Manzildan farqlanadi',
  //       'Teaching process: Online',
  //       'Duration: 50 hours',
  //       'Online chat with Teacher',
  //     ],
  //     image: '/images/audit.png',
  //   },
  //   {
  //     title: 'International Audit',
  //     price: '100.000 UZS',
  //     details: [
  //       'Manzildan farqlanadi',
  //       'Teaching process: Online',
  //       'Duration: 50 hours',
  //       'Online chat with Teacher',
  //     ],
  //     image: '/images/audit.png',
  //   },

  //   // Shu formatda yana kurslar qo‘shishingiz mumkin
  // ];
  const [swiperRef, setSwiperRef] = useState(null);

  let appendNumber = 4;
  let prependNumber = 1;

  const prepend2 = () => {
    swiperRef.prependSlide([
      '<div class="swiper-slide">Slide ' + --prependNumber + '</div>',
      '<div class="swiper-slide">Slide ' + --prependNumber + '</div>',
    ]);
  };

  const prepend = () => {
    swiperRef.prependSlide(
      '<div class="swiper-slide">Slide ' + --prependNumber + '</div>'
    );
  };

  const append = () => {
    swiperRef.appendSlide(
      '<div class="swiper-slide">Slide ' + ++appendNumber + '</div>'
    );
  };

  const append2 = () => {
    swiperRef.appendSlide([
      '<div class="swiper-slide">Slide ' + ++appendNumber + '</div>',
      '<div class="swiper-slide">Slide ' + ++appendNumber + '</div>',
    ]);
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(`${API}/courses/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        // 🔥 Faqat o‘sha ID dagi kursni topish
        const filtered = response.data.filter(
          (course) => String(course.id) === String(courseId)
        );
        setCourses(filtered);
        console.log("filtered course", filtered);
        // 🔥 Agar ID yo‘q bo‘lsa — barcha kurslarni ko‘rsatamiz
        // setCourses(response.data);
      } catch (error) {
        console.error("Kurslarni olishda xato:", error);
      } finally {
      }
    };

    fetchCourses();
  }, [courseId]);
  const handlePlayClick = (courseId) => {
    navigate(`/courses/${courseId}`);
  };

  const goToCourse = () => {
    const token = localStorage.getItem('token');

    if (token) {
      try {
        api.post(`${API}/student/enroll?course_id=${courseId}`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }).then((res) => {
          toast.success(t("enrolledSuccess"));
          navigate(`/student/courses/${res?.data?.id}`);

        }).catch((err) => {
          if (err.response?.status === 409) {
            api.get(`${API}/student/learning/enrollments`, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            }).then((response) => {
              const filtered = response.data.filter(
                (course) => String(course.course.id) === String(courseId)
              );
              navigate(`/student/courses/${filtered[0]?.id}`);
              console.log("filtered enroll", filtered);
            })
              .catch((error) => {
                console.error(error);
              });
          }

          if (err.response?.status === 403) {
            toast.warning(t("firstLogin"));
          }
        })
      } catch (err) {
        toast.error(t("errorOccured"))
      }
    } else {
      toast.error(t("loginFirst"))
    }
  };

  return (
    <div>
      <div className="homeNavbar">{<Navbar />}</div>
      <div className="home-nav">
        <div className="container home-navbar">
          <div className="home-nav-left">
            <img src={CallImg} alt="call img" className="call" />
            <a href="tel:+1 (7635) 547 12 97" className="home-nav-link">+1 (7635) 547 12 97</a>
            <img src={MessageImg} alt="call img" className="call" />
            <a href="mailto:iifa@edu.com" className="home-nav-link">iifa@edu.com</a>
          </div>
          <div className="home-nav-right">
            <i className="ri-map-pin-2-fill maps"></i>
            <a href="https://www.google.com/maps/place/%D0%AE%D0%BD%D1%83%D1%81%D0%BE%D0%B1%D0%BE%D0%B4+%D1%82%D1%83%D0%BC%D0%B0%D0%BD%D0%B8,+%D0%A2%D0%BEshkent,+Toshkent+Viloyati,+O%CA%BBzbekiston/@41.3531017,69.2704396,5495m/data=!3m1!1e3!4m6!3m5!1s0x38ae8cb23888afb9:0x31c22300affbc36a!8m2!3d41.3665717!4d69.2922267!16s%2Fm%2F02vvvwz?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D" className="home-nav-link">Uzbekistan, Tashkent city, Yunusabad district</a>
            <div className="luanguage-block">
              <div className="lang-select-wrapper">
                <button className="lang-button" onClick={() => setOpen(!open)}>
                  <img src={currentLang.flag} alt={language} />
                  <i className="ri-arrow-down-s-line lang-btn"></i>
                </button>

                {open && (
                  <div className="lang-dropdown">
                    {languages.map((lang) => (
                      <>
                        <div onClick={() => handleSelect(lang.code)} className="lang-box">
                          <div
                            key={lang.code}
                            className="lang-option"
                            onClick={() => handleSelect(lang.code)}
                          >
                            <img src={lang.flag} alt={lang.code} />
                          </div>
                          <span className="lang-name">{lang.name}</span>
                        </div>
                      </>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="header">
          <img src={HeaderImg} alt="" className="header-logo" />
          <div className="header-nav">
            {navItems.map((item, index) => (
              <li key={index} className="nav-list-item">
                <NavLink
                  to={item.key === "home" ? "/" : `/${item.key}`}
                  onClick={() => setActiveNav(false)}
                  className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </div>
          <img className="play-icon" src={Play} alt="call image" />
          <h1 className="header-trans-title">{t("headerWelcome")}</h1>
          <h1 className="header-title">{t("headerTitle1")}</h1>
          <h1 className="header-title">{t("headerTitle2")}</h1>
          <p className="header-text">{t("headerText")}</p>
          {!!user ? (
            <NavLink className="hide-userName" to="/student/info">
              <button className="button login-button head-btn">{user.first_name} {user.last_name}</button>
            </NavLink>
          ) : (
            <button onClick={() => setIsLoginOpen(true)} className="button login-button head-btn">
              {t("loginBtn")} <i className="ri-checkbox-circle-line checkIcon color-white"></i>
            </button>
          )}
        </div>

        {/* <div className="container">
          <div className="aboutPlatformDesc">
            <p className="aboutPlatformText">{t('aboutPlatformText')}</p>
            <p className="aboutPlatformTitle">{t('aboutPlatformTitle')}</p>
          </div>
        </div> */}
      </div>

      <div className="container">
        <h1 className="redline-text">{t("coursesTitle")}</h1>
        <p className="courses-desc">{t("coursesDesc")}</p>

        <div className="course-swiper-container">
          <div

            className=""
            style={{ margin: "auto", width: "350px", marginBottom: '40px' }}
          >
            {courses?.map((item, index) => (
              <div className="course-swipe" key={index}>
                <div className="swipe-card">
                  <img src={`${API}/${item.photo}`} alt="" className="swipe-card-img" />
                  <h3 className="swipe-title">{item.title}</h3>
                  <h3 className="swipe-price">{item.price} {t('price')}</h3>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-presentation-line"></i>
                    <span className="swipe-teacher">{item.mentor.first_name} {item.mentor.last_name}</span>
                  </div>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-checkbox-circle-line"></i>
                    <span className="swipe-teacher">{t("teachingProcess")}</span>
                  </div>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-checkbox-circle-line"></i>
                    <span className="swipe-teacher">{t("duration")}</span>
                  </div>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-checkbox-circle-line"></i>
                    <span className="swipe-teacher">{t("onlineChat")}</span>
                  </div>
                  <button onClick={goToCourse} className="swipe-btn">{t("getStarted")} <i className="ri-arrow-right-line right"></i></button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="courses-mobil">
          <Swiper pagination={true} spaceBetween={30} modules={[Pagination]} className="mySwiper">
            {courses?.map((item, index) => (
              <SwiperSlide className="course-swipe" key={index}>
                <div className="swipe-card">
                  <img src={`${API}/${item.photo}`} alt="" className="swipe-card-img" />
                  <h3 className="swipe-title">{item.title}</h3>
                  <h3 className="swipe-price">{item.price} {t('price')}</h3>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-presentation-line"></i>
                    <span className="swipe-teacher">{item.mentor.first_name} {item.mentor.last_name}</span>
                  </div>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-checkbox-circle-line"></i>
                    <span className="swipe-teacher">{t("teachingProcess")}</span>
                  </div>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-checkbox-circle-line"></i>
                    <span className="swipe-teacher">{t("duration")}</span>
                  </div>
                  <div className="swipe-teach">
                    <i className="swipe-icon ri-checkbox-circle-line"></i>
                    <span className="swipe-teacher">{t("onlineChat")}</span>
                  </div>
                  <button onClick={goToCourse} className="swipe-btn">{t("getStarted")} <i className="ri-arrow-right-line right"></i></button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {/* <ListCourses /> */}

      <div className="knowledge-box">
        <div className="knowledge container">
          <div className="knowledge-left">
            <h1 className="redline-text whiteLine">{t('CertificatesName')}</h1>
            <p className="knowledge-desc">{t('knowledgeDesc')}</p>
            <h2 className="knowledge-title">{t('knowledgeTitle')}</h2>
          </div>
          <div className="knowledge-right">
            <Slider />
          </div>

        </div>
      </div>
      <div className="news container">
        <h1 className="redline-text news-line">{t("studentsSay")}</h1>
        <Swiper
          onSwiper={setSwiperRef}
          slidesPerView={3}
          centeredSlides={true}
          spaceBetween={20}
          pagination={{
            type: 'bullets',
          }}
          initialSlide={2}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="mySwiper news-swiper"
        >
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Johongir} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Jakhongir Artikkhodjayev</h5>
                <span className="our-role">{t("student2Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim  minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Shagzod} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Shakhzod Bakhodirov</h5>
                <span className="our-role">{t("student2Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Marifat} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Marifat Jamal</h5>
                <span className="our-role">{t("student3Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Johongir} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Jakhongir Artikkhodjayev</h5>
                <span className="our-role">{t("student2Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
        </Swiper>

        <Swiper pagination={true} modules={[Pagination]} className="mySwiper news-mobile">
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Johongir} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Jakhongir Artikkhodjayev</h5>
                <span className="our-role">{t("student2Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim  minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Shagzod} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Shakhzod Bakhodirov</h5>
                <span className="our-role">{t("student2Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Marifat} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Marifat Jamal</h5>
                <span className="our-role">{t("student3Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
          <SwiperSlide className="our-box">
            <div className="our-profile">
              <img src={Johongir} alt="profile image" className="our-img" />
              <div className="name-block">
                <h5 className="our-name">Jakhongir Artikkhodjayev</h5>
                <span className="our-role">{t("student2Role")}</span>
              </div>
            </div>
            <p className="our-desc">Lorem ipsum dolor sit amet, Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
          </SwiperSlide>
        </Swiper>
      </div>
      {isLoginOpen && (<Login setIsModalOpen={setIsLoginOpen} />)}
    </div>
  );
};

export default Home;
